<script setup>
import {ref, reactive, onMounted, watch, useTemplateRef, computed, nextTick} from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router';
import { useRouter } from 'vue-router';
import { useCommonComposable } from '@/composables/commonComposable.js';

const store = useStore()
const route = useRoute()
const router = useRouter()

const { setImageURL, setImageThumbURL, sizes } = useCommonComposable();

const props = defineProps({
    products: {
        type: Array,
        default: () => [],
    }
});

const swipeContainer = useTemplateRef('swiperContainer');
const container = useTemplateRef('container');
const itemWidth = ref(0)

const startX = ref(itemWidth);
const SWIPE_THRESHOLD = 30;

const onTouchStart = (event) => {
    startX.value = event.touches[0].clientX;
};

const onTouchMove = (event) => {
    if (startX.value === null) return;

    const currentX = event.touches[0].clientX;
    const deltaX = currentX - startX.value;
};

const onTouchEnd = (event) => {
    if (startX.value === null) return;

    const endX = event.changedTouches[0].clientX;
    const deltaX = endX - startX.value;

    const containerWidth = swipeContainer.value.getBoundingClientRect().width
    const margin = parseInt(getComputedStyle(swipeContainer.value.querySelectorAll('.product-item')[0]).marginLeft)
    let itemWidth = swipeContainer.value.querySelector('.product-item').getBoundingClientRect().width;

    itemWidth = itemWidth - (containerWidth-itemWidth)/2 + 5 + margin

    // if (swipeContainer.value.scrollLeft <= itemWidth || swipeContainer.value.scrollLeft >= itemWidth * swipeContainer.value.querySelectorAll('.product-item').length) {
    //     itemWidth = itemWidth + margin
    // }

    // Определим направление свайпа
    if (Math.abs(deltaX) > SWIPE_THRESHOLD) {
        if (deltaX > 0) {
            swipeRight(itemWidth); // Выполняем свайп вправо

        } else {
            swipeLeft(itemWidth); // Выполняем свайп влево
        }
    }

    startX.value = null;
};

// Вспомогательные методы
const swipeRight = (width, behavior) => {
    let scrollNow = swipeContainer.value.scrollLeft || 0
    swipeContainer.value.scrollTo({ left: `${scrollNow-width}`, behavior: behavior ? behavior : 'smooth' });
};

const swipeLeft = (width, behavior) => {
    let scrollNow = swipeContainer.value.scrollLeft || 0
    swipeContainer.value.scrollTo({ left: `${scrollNow+width}`, behavior: behavior ? behavior : 'smooth' });
};

onMounted(async () => {
})

watch(props, async (newVal) => {
    if (newVal.products.length > 0) {
        await nextTick() // ждем следующий кадр, чтобы DOM успел сформировать элементы

        if (swipeContainer.value) {
            const firstItem = swipeContainer.value.querySelector('.product-item')

            const margin = parseInt(getComputedStyle(swipeContainer.value.querySelectorAll('.product-item')[0]).marginLeft)
            if (firstItem) {
                itemWidth.value = firstItem.getBoundingClientRect().width

                const containerWidth = swipeContainer.value.getBoundingClientRect().width
                itemWidth.value = itemWidth.value - (containerWidth-itemWidth.value)/2 + 5 + margin
                // itemWidth.value = containerWidth * 0.90

                swipeLeft(itemWidth.value, 'instant')
            }
        }
    }
}, { immediate: true }) // наблюдаем сразу при создании компонента

</script>

<template>

            <div
                class="popular-products"
                v-if="products.length > 0"
                ref="swiperContainer"
                @touchstart="onTouchStart"
                @touchmove="onTouchMove"
                @touchend="onTouchEnd"
            >
                <router-link :to="{name: 'product-item', params: {code: item.code}}" v-for="item of products" class="product-item">
                    <div class="item-img" :style="`background: ${item.imageUrl ? 'url(' + setImageThumbURL(item.imageUrl) + ')' : '#fff'}`"></div>

                    <div class="product-head-info">
                        <p class="product-name">{{ item.product_name }}</p>
                        <p class="product-item-size">{{ sizes[item.size_name] }}</p>
                    </div>
                    <div class="product-item-price">
                        <div class="sale-block" v-if="item['sale_price'] !== 0 && item['sale_price'] < item['common_price']">
                            <p class="sale-price">{{ item['sale_price'] }}&#8381;</p>
                            <p class="default-price">{{ item['common_price'] }}&#8381;</p>
                        </div>
                        <div class="default-block" v-else>
                            <p class="sale-price">{{ item['common_price'] }}&#8381;</p>
                        </div>
                    </div>
                </router-link>
            </div>
</template>

<style scoped lang="scss">
    @use '~@/assets/styles/vars' as *;
    .popular-products {
        display: flex;
        flex-direction: row;
        gap: 5px;
        flex-wrap: nowrap;
        overflow-x: hidden;
        width: 100%;
    }

    .product-item:first-child {
        margin-left: 2.5%;
    }

    .product-item:last-child {
        margin-right: 2.5%;
    }

    .product-item {
        flex-shrink: 0;
        width: 93%;
        background: linear-gradient(180deg, #FFFFFF 70%, rgba(255, 255, 255, 0));
        padding: 30px;
        box-sizing: border-box;
        border-radius: 30px;

        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
    }

    .item-img {
        width: 100%;
        height: auto;
        aspect-ratio: 1 / 1;

        background-position: center center !important;
        background-size: cover !important;
    }

    .product-head-info {
        display: flex;
        flex-direction: column;
        gap: 3px;
    }

    .product-name {
        font-size: 18px;
        color: $black;
        font-weight: 500;
        text-align: center;
    }

    .product-item-size {
        font-size: 14px;
        font-family: "PT Sans Narrow";
        color: $hard-gray;
        text-align: center;
    }

    .sale-price {
        font-size: 22px;
        color: $black;
        font-weight: 500;
        text-align: center;
    }

    .default-price {
        font-size: 12px;
        color: $hard-gray;
        font-weight: 400;
        text-align: center;
        text-decoration: line-through;
    }
</style>